import { FC } from 'react'
import { BsSortAlphaDown, BsSortAlphaDownAlt } from 'react-icons/bs'

type Props = {
  isAsc: boolean
}

const LetterAscDescSort: FC<Props> = (props) => {
  const { isAsc } = props

  return (
    <>
      {isAsc ? (
        <>
          <span>昇順</span>
          <BsSortAlphaDown size={'1rem'} />
        </>
      ) : (
        <>
          <span>降順</span>
          <BsSortAlphaDownAlt size={'1rem'} />
        </>
      )}
    </>
  )
}

export default LetterAscDescSort
